import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M9.977 7c.026 0 .649.04 1.316.707a1 1 0 0 0 1.414-1.414A4.487 4.487 0 0 0 11 5.2V5a1 1 0 1 0-2 0v.184A2.996 2.996 0 0 0 7 8c0 2.28 1.727 2.713 2.758 2.97C10.873 11.25 11 11.354 11 12c0 .552-.448 1-.976 1-.026 0-.65-.04-1.317-.707a1 1 0 0 0-1.414 1.415A4.502 4.502 0 0 0 9 14.798v.2a1 1 0 1 0 2 0v-.184A2.995 2.995 0 0 0 13 12c0-2.28-1.726-2.712-2.757-2.97C9.128 8.752 9 8.646 9 8c0-.55.449-1 .977-1"
});

var SvgCashDollarMajorMonotone = function SvgCashDollarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCashDollarMajorMonotone as S };
